export default "__VITE_ASSET__07dbc489__"